import React from 'react';
import {Link, useLocation, useNavigate} from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import Logo from './Logo';

const {FiArrowUpRight, FiMail, FiPhone} = FiIcons;

export default function Footer() {
  const navigate = useNavigate();
  const location = useLocation();

  const goToServices = () => {
    if (location.pathname !== '/home') {
      navigate('/home');
      window.setTimeout(() => document.getElementById('services')?.scrollIntoView({behavior: 'smooth'}), 150);
    } else {
      document.getElementById('services')?.scrollIntoView({behavior: 'smooth'});
    }
  };

  return (
    <footer className="bg-[#0b1423] border-t border-white/10 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-8">
        <div className="grid sm:grid-cols-2 lg:grid-cols-[2fr_1fr_1fr] gap-12 pb-16">
          <div>
            <Link to="/home" onClick={() => window.scrollTo(0, 0)} className="inline-block"><Logo size="lg" /></Link>
            <p className="text-slate-400 max-w-sm leading-relaxed mt-6">Helping local businesses get found,build trust and turn attention into opportunity.</p>
            <Link to="/pricing" className="inline-flex gap-2 items-center text-[#3fc0fa] font-bold mt-6 hover:text-white transition-colors">
              Explore the plan <SafeIcon icon={FiArrowUpRight} />
            </Link>
          </div>
          <div>
            <h2 className="font-bold mb-6">Explore</h2>
            <div className="flex flex-col items-start gap-4 text-sm">
              <button onClick={goToServices} className="site-link">Services</button>
              <Link to="/results" className="site-link">Results</Link>
              <Link to="/pricing" className="site-link">Pricing</Link>
            </div>
          </div>
          <div>
            <h2 className="font-bold mb-6">Get in touch</h2>
            <div className="flex flex-col gap-4 text-sm">
              <a href="mailto:support@jellylocal.com" className="site-link inline-flex items-center gap-3 break-all"><SafeIcon icon={FiMail} className="shrink-0 text-[#3fc0fa]" /> support@jellylocal.com</a>
              <a href="tel:2512431403" className="site-link inline-flex items-center gap-3"><SafeIcon icon={FiPhone} className="text-[#3fc0fa]" /> 251-243-1403</a>
            </div>
          </div>
        </div>
        <div className="border-t border-white/10 pt-7 flex flex-col sm:flex-row gap-5 justify-between text-sm text-slate-400">
          <p>© 2026 Jelly Local. All rights reserved.</p>
          <div className="flex gap-6">
            <Link to="/privacy" className="site-link">Privacy Policy</Link>
            <Link to="/terms" className="site-link">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}